// ============================================================
// chosung.js — 한글 초성 검색 도우미
//
// [원리]
//  한글 글자는 유니코드에서 규칙적으로 배열돼 있다.
//    글자코드 = 0xAC00 + (초성순번 × 588) + (중성순번 × 28) + 종성순번
//  이 식을 거꾸로 풀면 초성만 뽑아낼 수 있다.
//    "남부순환로" → "ㄴㅂㅅㅎㄹ"
//
// [사용처] StaffIntake.jsx 의 도로명 검색칸
//  · "ㄴㅂ"  입력 → 초성이 ㄴㅂ 로 시작하는 도로명
//  · "남부"  입력 → 이름에 남부가 들어간 도로명
//  두 방식을 함께 지원해 직원이 아무렇게나 쳐도 찾아진다.
// ============================================================

// 초성 19자 — 유니코드 순서 그대로여야 한다
const CHO = [
  "ㄱ","ㄲ","ㄴ","ㄷ","ㄸ","ㄹ","ㅁ","ㅂ","ㅃ","ㅅ",
  "ㅆ","ㅇ","ㅈ","ㅉ","ㅊ","ㅋ","ㅌ","ㅍ","ㅎ",
];

// 문자열에서 초성만 뽑는다. 한글이 아니면 그대로 둔다.
// 예) "남부순환로230길" → "ㄴㅂㅅㅎㄹ230ㄱ"
export function toChosung(str) {
  let out = "";
  for (const ch of String(str || "")) {
    const code = ch.charCodeAt(0);
    if (code >= 0xac00 && code <= 0xd7a3) {
      // 완성형 한글 → 초성 계산
      out += CHO[Math.floor((code - 0xac00) / 588)];
    } else {
      out += ch;
    }
  }
  return out;
}

// 입력값이 초성만으로 이루어졌는지 판단
// (초성만 쳤을 때와 글자를 쳤을 때 검색 방식을 다르게 하기 위함)
export function isChosungOnly(q) {
  const s = String(q || "").replace(/\s/g, "");
  if (!s) return false;
  return [...s].every((ch) => CHO.includes(ch));
}

// 도로명 하나가 검색어에 걸리는지 판정
//   q 가 초성만 → 도로명의 초성이 q 로 시작하는지
//   q 가 일반글자 → 도로명에 q 가 포함되는지
export function matchRoad(name, q) {
  const query = String(q || "").replace(/\s/g, "");
  if (!query) return true;                  // 검색어 없으면 전체 표시

  if (isChosungOnly(query)) {
    return toChosung(name).startsWith(query);
  }
  return String(name).includes(query);
}